/**
 * Sorting wallboxes function used for sorted order of wallboxes and wallboxes filter options in emobility section
 * Descending sorting behavior requested which takes wallbox name as priority during sorting.
 * Compare by wallbox name first
 * If wallboxA has a name but wallboxB does not, wallboxA comes first
 * If wallboxB has a name but wallboxA does not, wallboxB comes first
 * If neither have a name, sort by ID using default alphanumeric sorting
 */
export const wallboxSortFn = (
  wallboxA: { wallboxName: string | undefined; wallboxId: string },
  wallboxB: { wallboxName: string | undefined; wallboxId: string }
): number => {
  if (wallboxA.wallboxName && wallboxB.wallboxName) {
    return wallboxA.wallboxName.localeCompare(wallboxB.wallboxName)
  }

  if (wallboxA.wallboxName && !wallboxB.wallboxName) {
    return -1
  }

  if (!wallboxA.wallboxName && wallboxB.wallboxName) {
    return 1
  }

  return wallboxA.wallboxId.localeCompare(wallboxB.wallboxId)
}
